var render = function render(){var _vm=this,_c=_vm._self._c;return _c('H5Layout',{attrs:{"title":"文件管理","active":"document"}},[_c('ZDocument')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }